import { useMutation, useQueryClient } from '@tanstack/react-query'
import { TraceKeysApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export const useMutationDeleteTraceKey = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (traceKeyId: number) => {
      return await baseClient
        .getApi(TraceKeysApi)
        .deleteTraceKey({ traceKeyId })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      // 成功時にtraceKeysクエリを無効化して再取得する
      queryClient.invalidateQueries({ queryKey: queryKeys.lists() })
    },
  })
}
